module.exports = __webpack_public_path__ + "img/kv.484824cf.png";